module.exports = __webpack_public_path__ + "img/library.c1fe62a3.png";